<template>
  <div class="tokyo_tm_contact" style="min-width: 400px;">
    <div class="fields">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form class="contact_form" @submit.prevent="handleSubmit(onSubmit)">
          <div class="first">
            <ul class="contact_ul">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ errors }"
              >
                <li>
                  <div class="inpur-error">{{ errors[0] ? '*' : null }}</div>
                  <input
                    class="contact_input"
                    v-model="formData.name"
                    type="text"
                    placeholder="Name"
                    autocomplete="off"
                  />
                </li>
              </ValidationProvider>

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <li>
                  <div class="inpur-error">{{ errors[0] ? '*' : null }}</div>
                  <input
                    class="contact_input"
                    type="text"
                    rules="required|email"
                    v-model="formData.email"
                    placeholder="Email"
                  />
                </li>
              </ValidationProvider>
              <ValidationProvider
                name="message"
                rules="required"
                v-slot="{ errors }"
              >
                <li>
                  <div class="inpur-error">{{ errors[0] ? '*' : null }}</div>
                  <textarea
                    v-model="formData.message"
                    placeholder="Message"
                    style="max-width: 80%;"
                  ></textarea>
                </li>
              </ValidationProvider>
            </ul>
          </div>
          <div class="tokyo_tm_button">
            <button :disabled="sending" type="submit" class="white-fill-bg fill-black" :class="{buttonDisabled: sending}" style="margin-top:20px; width:100%; max-width: 80%">
              Send Message
            </button>
          </div>
          <div class="messageSent" :class="{messageSentVisible: sent}">Sent Message!</div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END FIELDS -->
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        message: "",
      },
      sending: false,
      sent: false,
    };
  },
  methods: {
    onSubmit() {
      this.sending = true
      this.sent = false
      this.$store.dispatch('ActionSubmitContactForm', this.formData).then(() => {
        console.log('Sent 2')
        this.sent = true
        this.formData.name = ''
        this.formData.email = ''
        this.formData.message = ''
      })
    },
  },
};
</script>


<style lang="css">
.contact_ul {
  list-style: none;
}
.contact_input {
  margin-bottom: 40px;
  width: 100%;
  max-width: 80%;
}
.inpur-error {
  position: absolute;
  margin-top: 0px;
  color: red;
  right: 10px;
}
.messageSent {
  position: absolute;
  width: 100%;
  background: black;
  color: white;
  margin-top: 20px;
  transition: opacity .5s ease;
  opacity: 0;
}
.messageSent.messageSentVisible{
  opacity: 1;
}
.buttonDisabled {
  pointer-events: none;
  opacity: .5;
}
</style>